import React, { useState } from 'react';
import { getData, postData } from '../store/utils';
import { FaDownload } from 'react-icons/fa';
import { HiRefresh } from "react-icons/hi";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import Loader from '../component/Loader';
import { formatDate } from '../component/common';
import { format, subDays, startOfWeek, endOfWeek, startOfMonth, endOfMonth, subWeeks, subMonths } from "date-fns";
import Select from "react-select";

const OrderSubMenuFile = () => {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [data, setData] = useState(null);
  const [isLoadingOn, setIsLoadingOn] = useState(false);
  const [todayDate, setTodayDate] = useState(null);
  const [filterData, setFilterData] = useState('overall');
  const [selectedStatusOption, setSelectedStatusOption] = useState([]);

  const statusOption = [
    { value: 'today', label: 'Today' },
    { value: 'yesterday', label: 'Yesterday' },
    { value: 'currentWeek', label: 'Current Week' },    
    { value: 'lastWeek', label: 'Last Week' }, 
    { value: 'currentMonth', label: 'Current Month' },
    { value: 'lastMonth', label: 'Last Month' },
    { value: 'overall', label: 'Overall' }, 
  ];

  const orderStatusOption = [
    { label: "All", value: null },
    { label: "Approved", value: 5 },
    { label: "Quotation Pending", value: 35 },
    { label: "Merchant Approval Pending", value: 36 },
    { label: "Invoice Upload Pending", value: 29 },
    { label: "Pending", value: 3 },
    { label: "Decline", value: 10 },
    { label: "Delete", value: 11 },
  ]

  const handleFromDateChange = (date) => {
    const formattedDate = date ? format(date, 'yyyy-MM-dd') : null;
    setFromDate(formattedDate);
  };

  const handleToDateChange = (date) => {
    const formattedDate = date ? format(date, 'yyyy-MM-dd') : null;
    setToDate(formattedDate);
  };

  console.log("date++++", fromDate, toDate)

  const fetchData = async () => {

    try {
      const today = format(new Date(), "yyyy-MM-dd");
      setTodayDate(today);
      setIsLoadingOn(true);

      if (!filterData && !fromDate && !toDate) {
        Swal.fire({
          icon: "warning",
          title: "Select a date filter or manual date range",
        });
        setIsLoadingOn(false);
        return;
      }

      let computedFromDate = fromDate;
      let computedToDate = toDate;
    
      switch (filterData) {
        case "today":
          computedFromDate = today;
          computedToDate = today;
          break;
  
        case "yesterday":
          computedFromDate = format(subDays(new Date(), 1), "yyyy-MM-dd");
          computedToDate = computedFromDate;
          break;
  
        case "currentWeek":
          computedFromDate = format(startOfWeek(new Date(), { weekStartsOn: 0 }), "yyyy-MM-dd");
          computedToDate = format(endOfWeek(new Date(), { weekStartsOn: 0 }), "yyyy-MM-dd");
          break;
  
        case "lastWeek":
          computedFromDate = format(startOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 0 }), "yyyy-MM-dd");
          computedToDate = format(endOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 0 }), "yyyy-MM-dd");
          break;
    
        case "currentMonth":
          computedFromDate = format(startOfMonth(new Date()), "yyyy-MM-dd");
          computedToDate = format(endOfMonth(new Date()), "yyyy-MM-dd");
          break;
  
        case "lastMonth":
          computedFromDate = format(startOfMonth(subMonths(new Date(), 1)), "yyyy-MM-dd");
          computedToDate = format(endOfMonth(subMonths(new Date(), 1)), "yyyy-MM-dd");
          break;
    
        case "overall":
          computedFromDate = null;
          computedToDate = null;
          break;
        
        default:
          break;
      }

      const selectedStatusArray = selectedStatusOption
        ?.filter((s) => s.value !== null)
        ?.map((s) => s.value);

      const filterBody = {
        fromDate: computedFromDate || fromDate,
        toDate: computedToDate || toDate,
        status: selectedStatusArray.length ? selectedStatusArray : [],
      };

      const response = await postData(`users/orderExport`, filterBody);
      setIsLoadingOn(false);
      if (response.statusCode == 200) {
        const file = window.open(response.data.Location);
        if (file) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: "File Download successfully!",
          });
        } else {
          Swal.fire({
            icon: "Error",
            title: "Error!",
            text: "Error In File Download!",
          });
        }

      } else {
        Swal.fire({
          icon: "error",
          text: `${response.data.errors.msg}`,
        });
      }


    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleDownload = () => {
    if (data) {
      const fileName = 'order_data.csv'; // Example file name
      const csv = convertDataToCSV(data); // Assuming convertDataToCSV is a function to convert data to CSV format
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement('a');
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }
  };

  const convertDataToCSV = (data) => {
    // Example function to convert data to CSV format
    const header = Object.keys(data[0]).join(',');
    const csv = data.map(row => Object.values(row).join(',')).join('\n');
    return `${header}\n${csv}`;
  };

  return (
    <>
      {isLoadingOn ? <Loader /> : ''}
      <h3 className='tableHeaderMsg'>Orders File</h3>
      <div className='customHeaderTable distable'>
        <div className="container-fluid">
          <div className="row alignmentTable">
            <div className="col-md-2">
              <Select
                isMulti
                placeholder="Select Status"
                name="status"
                options={orderStatusOption}
                onChange={(selected) => setSelectedStatusOption(selected)}
                value={selectedStatusOption}
              />
            </div>
            <div className="col-md-2">
              <Select 
                defaultValue={statusOption[6]}
                placeholder="Onboarding Status"
                name="role"
                options={statusOption}
                onChange={(e) => setFilterData(e.value)}
              />
            </div>
            <div className="col-md-2">
              {/* <label>From :</label>&nbsp; */}
              <DatePicker
                className="form-control"
                dateFormat="dd-MM-yyyy"
                selected={fromDate ? new Date(fromDate) : null}
                onChange={handleFromDateChange}
                placeholderText="Select Start Date"
                maxDate={new Date()}
              />
            </div>
            <div className="col-md-2">
              {/* <label>To :</label>&nbsp; */}
              <DatePicker
                className="form-control"
                dateFormat="dd-MM-yyyy"
                selected={toDate ? new Date(toDate) : null}
                onChange={handleToDateChange}
                placeholderText="Select End Date"
                maxDate={new Date()}
              />
            </div>
            <div className="col-md-2 text-center">
              <button className='searchTableData' onClick={fetchData}><FaDownload /> Order </button>
            </div>
            <div className="col-md-2 text-center">
              <button
                className='resetTableData'
                onClick={() => {
                  setFromDate(null);
                  setToDate(null);
                  setFilterData('');
                  setSelectedStatusOption(null);
                  window.location.reload();
                }}
              >
                <HiRefresh /> Reset
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* {isLoadingOn ? <Loader /> : null} */}
      {/* Display your table or other components here */}
    </>
  );
};

export default OrderSubMenuFile;
